import {FC, lazy, Suspense} from 'react'
import {Navigate, Route, Routes} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import DashboardLogs from '../pages/dashboard/DashboardLogs'
import AllAnnouncementDashboardLogs from '../pages/dashboard/AllAnnouncementDashboardLogs'
import ViewAllNotifications from '../../_metronic/partials/layout/header-menus/ViewAllNotifications'

// Lazy Imports
const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
const EmployeePage = lazy(() => import('../pages/Employees/EmployeePage'))
const SettingPage = lazy(() => import('../pages/Settings/Setting-page/SettingPage'))
const OrganizationPage= lazy(() => import('../pages/organization/components/organization-page/OrganizationPage'))
const UserManagementPage=lazy(() => import('../pages/UserManagement/UserManagment-page/UserManagementPage'));
const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))
const ReportPage = lazy(() => import('../pages/Reports/ReportPage'))


const PrivateRoutes = () => {
  // --- Condition Logic ---
  // Yahan aap apni condition ka logic likhein.
  // Yeh condition true honi chahiye agar user ko sab routes access karne hain.
  // Agar false hai, to sirf profile page access hoga.
  // Example: yeh user ke role, authentication status, ya kisi aur state par depend kar sakti hai.
  // **IMPORTANT:** Is placeholder ko apne actual logic se replace karein.
  const profileCompleted = localStorage.getItem('profile_completed');
  const canAccessAllRoutes = Number(profileCompleted) === 1;


  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route
          path='crafted/pages/profile/*' // Profile ka base path
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        {canAccessAllRoutes ? (
          <>
            {/* Redirect to Dashboard after success login/registration */}
            <Route path='auth/*' element={<Navigate to='/dashboard' />} />
            {/* Pages */}
            <Route path='dashboard' element={<DashboardWrapper />} />
             <Route path='/notifications' element={<ViewAllNotifications />} />
            <Route path='dashboard/announcement-Log' element={<DashboardLogs />} />
            <Route path='dashboard/all-announcements-Logs' element={<AllAnnouncementDashboardLogs />} />
            <Route path='builder' element={<BuilderPageWrapper />} />
            {/* Lazy Modules */}
            <Route
              path='hr/organization-managements/*'
              element={
                <SuspensedView>
                  <OrganizationPage/>
                </SuspensedView>
              }
            />
            <Route
              path='hr/employee/*'
              element={
                <SuspensedView>
                  <EmployeePage/>
                </SuspensedView>
              }
            />
              <Route
              path='/hr/settings/*'
              element={
                <SuspensedView>
                  <SettingPage/>
                </SuspensedView>
              }
            />
            <Route
              path='/hr/reports/*'
              element={
                <SuspensedView>
                  <ReportPage/>
                </SuspensedView>
              }
            />
            <Route
              path='/hr/user-managements/*'
              element={
                <SuspensedView>
                  <UserManagementPage/>
                </SuspensedView>
              }
            />
            <Route
              path='crafted/pages/wizards/*'
              element={
                <SuspensedView>
                  <WizardsPage />
                </SuspensedView>
              }
            />
            <Route
              path='crafted/widgets/*'
              element={
                <SuspensedView>
                  <WidgetsPage />
                </SuspensedView>
              }
            />
            <Route
              path='crafted/account/*'
              element={
                <SuspensedView>
                  <AccountPage />
                </SuspensedView>
              }
            />
            <Route
              path='apps/chat/*'
              element={
                <SuspensedView>
                  <ChatPage />
                </SuspensedView>
              }
            />
            <Route
              path='apps/user-management/*'
              element={
                <SuspensedView>
                  <UsersPage />
                </SuspensedView>
              }
            />
             <Route path='*' element={<Navigate to='/dashboard' />} />
          </>
        ) : (
          
          <>
            <Route path='*' element={<Navigate to='/crafted/pages/profile/overview' replace />} />
          </>
        )}
      </Route> {/* End MasterLayout Route */}
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}